import { render, staticRenderFns } from "./SelectTree.vue?vue&type=template&id=00248906"
import script from "./SelectTree.vue?vue&type=script&lang=js"
export * from "./SelectTree.vue?vue&type=script&lang=js"
import style0 from "./SelectTree.vue?vue&type=style&index=0&id=00248906&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports